import React, { useState, useEffect } from 'react';
import { Download } from 'lucide-react';
import { API_URL } from '../../config';

export default function TransactionsList({ adminData }) {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState('30d');

  useEffect(() => {
    fetchTransactions();
  }, [period]);

  const fetchTransactions = async () => {
    try {
      const token = localStorage.getItem('snapshot_token');
      const res = await fetch(`${API_URL}/api/admin/transactions?period=${period}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!res.ok) throw new Error('Failed to fetch transactions');
      
      const data = await res.json();
      setTransactions(data.transactions || []);
    } catch (error) {
      console.error('Error fetching transactions:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleExport = () => {
    const token = localStorage.getItem('snapshot_token');
    window.open(`${API_URL}/api/admin/export/transactions?period=${period}`, '_blank');
  };

  return (
    <div className="p-4 sm:p-6">
      <div className="max-w-full mx-auto">
        
        {/* Header */}
        <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <h2 className="text-2xl sm:text-3xl font-bold">
            Transaktionen <span className="text-[#10B981]">({period})</span>
          </h2>
          
          <div className="flex gap-2 sm:gap-3 flex-wrap">
            <select
              value={period}
              onChange={(e) => setPeriod(e.target.value)}
              className="flex-1 sm:flex-none px-3 sm:px-4 py-2.5 bg-black border border-white/30 rounded-xl text-white text-sm sm:text-base min-h-[44px]"
            >
              <option value="today">Heute</option>
              <option value="7d">7 Tage</option>
              <option value="30d">30 Tage</option>
              <option value="month">Monat</option>
              <option value="year">Jahr</option>
            </select>
            
            <button
              onClick={handleExport}
              className="flex-1 sm:flex-none px-4 py-2.5 bg-[#10B981] text-black rounded-xl hover:bg-[#059669] font-medium flex items-center justify-center gap-2 min-h-[44px] whitespace-nowrap"
            >
              <Download className="w-4 h-4" />
              <span className="hidden sm:inline">Export CSV</span>
              <span className="sm:hidden">Export</span>
            </button>
          </div>
        </div>

        {/* Table */}
        {loading ? (
          <div className="text-center py-12">
            <div className="animate-spin w-12 h-12 border-4 border-[#10B981] border-t-transparent rounded-full mx-auto"></div>
          </div>
        ) : (
          <div className="bg-black border-2 border-white/10 rounded-xl overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-white/5 border-b border-white/10">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-bold text-white/70">Datum</th>
                  <th className="px-4 py-3 text-left text-xs font-bold text-white/70">User</th>
                  <th className="px-4 py-3 text-left text-xs font-bold text-white/70">Paket</th>
                  <th className="px-4 py-3 text-right text-xs font-bold text-white/70">Brutto</th>
                  <th className="px-4 py-3 text-right text-xs font-bold text-white/70">Netto</th>
                  <th className="px-4 py-3 text-right text-xs font-bold text-white/70">MwSt 19%</th>
                  <th className="px-4 py-3 text-right text-xs font-bold text-white/70">Stripe</th>
                  <th className="px-4 py-3 text-right text-xs font-bold text-white/70">Astria</th>
                  <th className="px-4 py-3 text-right text-xs font-bold text-white/70">Marge</th>
                  <th className="px-4 py-3 text-left text-xs font-bold text-white/70">Status</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((tx) => (
                  <tr key={tx._id} className="border-b border-white/5 hover:bg-white/5">
                    <td className="px-4 py-3 text-white/70">
                      {new Date(tx.created_at).toLocaleString('de-DE')}
                    </td>
                    <td className="px-4 py-3 font-mono text-xs text-white/70">
                      {tx.user_id.substring(0, 8)}...
                    </td>
                    <td className="px-4 py-3 text-white">{tx.package_name}</td>
                    <td className="px-4 py-3 text-right font-bold text-white">€{tx.brutto}</td>
                    <td className="px-4 py-3 text-right text-white/70">€{tx.netto}</td>
                    <td className="px-4 py-3 text-right text-white/70">€{tx.mwst_19}</td>
                    <td className="px-4 py-3 text-right text-red-400">€{tx.stripe_fee}</td>
                    <td className="px-4 py-3 text-right text-orange-400">€{tx.astria_total}</td>
                    <td className="px-4 py-3 text-right font-bold text-[#10B981]">€{tx.margin}</td>
                    <td className="px-4 py-3">
                      <span className={`px-2 py-1 rounded text-xs font-bold ${
                        tx.payment_status === 'paid' ? 'bg-[#10B981]/20 text-[#10B981]' : 'bg-yellow-500/20 text-yellow-500'
                      }`}>
                        {tx.payment_status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {transactions.length === 0 && (
              <div className="text-center py-12 text-white/50">
                Keine Transaktionen gefunden
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  );
}
